import { RoleResponseDTO } from '@/core/api/dtos/response/role/role'
import { Role } from '@/core/api/entities/role/role'
import { GenericMapper } from '@/core/api/mappers/genericMapper'

export class RoleMapper {
	static toEntity(dto: RoleResponseDTO): Role {
		const dates = GenericMapper.mapDates({
			createdAt: dto.created_at,
			updatedAt: dto.updated_at,
		})

		return Role.create({
			id: dto.id,
			public_name: dto.public_name,
			description: dto.description,
			createdAt: dates.createdAt,
			updatedAt: dates.updatedAt,
		})
	}

	static toEntities(dtos: RoleResponseDTO[]): Role[] {
		return dtos.map((dto) => RoleMapper.toEntity(dto))
	}
}
